module.exports = __webpack_public_path__ + "img/firework-2.b705cb19.png";